<div class="px-3 md:px-10 xl:px-[111px]">
    <div class="xl:px-[64px]">
        <div class="text-font32px leading-[34px] font-bold text-[#222222]">Più risultati, meno complessità.</div>
        <div class="mt-5 text-font20px text-[#364349] leading-[26px] mb-[106px]">Innovation Smart Plaza ti offre un
            vantaggio competitivo concreto: ti permette di
            individuare rapidamente le opportunità giuste, preparare candidature effcaci, creare reti
            solide e gestire ogni fase del progetto in modo strutturato e intelligente.</div>
        <div class="md:flex flex-wrap gap-8">
            <div class="flex gap-5 md:w-[calc(50%-16px)] items-center">
                <div class="text-[128px] font-bold text-[#719CFF]">1</div>
                <div class="text-font24px font-bold leading-[34px] text-[#222222]">Più tempo per innovare, meno tempo
                    sprecato nella ricerca e burocrazia.</div>
            </div>
            <div class="flex gap-5 md:w-[calc(50%-16px)] items-center">
                <div class="text-[128px] font-bold text-[#719CFF]">2</div>
                <div class="text-font24px font-bold leading-[34px] text-[#222222]">Più precisione, grazie a un motore AI
                    che seleziona solo i bandi in
                    linea con il tuo profilo.</div>
            </div>
            <div class="flex gap-5 md:w-[calc(50%-16px)] items-center">
                <div class="text-[128px] font-bold text-[#719CFF]">3</div>
                <div class="text-font24px font-bold leading-[34px] text-[#222222]">Più possibilità di successo, con
                    strumenti e consulenza dedicati alla
                    tua strategia.</div>
            </div>
            <div class="flex gap-5 md:w-[calc(50%-16px)] items-center">
                <div class="text-[128px] font-bold text-[#719CFF]">4</div>
                <div class="text-font24px font-bold leading-[34px] text-[#222222]">Più connessioni di valore, per trovare
                    i partner giusti e rafforzare la tua proposta.</div>
            </div>
            <div class="flex gap-5 md:w-[calc(50%-16px)] items-center">
                <div class="text-[128px] font-bold text-[#719CFF]">5</div>
                <div class="text-font24px font-bold leading-[34px] text-[#222222]">Più controllo, con dashboard evolute
                    per monitorare l'andamento del
                    progetto.</div>
            </div>
            <div class="flex gap-5 md:w-[calc(50%-16px)] items-center">
                <div class="text-[128px] font-bold text-[#719CFF]">6</div>
                <div class="text-font24px font-bold leading-[34px] text-[#222222]">Tutto ciò che ti serve per trasformare
                    un'idea in impatto.</div>
            </div>
        </div>
    </div>
    <div class="p-5 md:py-[75px] md:px-[53px] gap-5 place-content-between rounded-[20px] xl:flex bg-[#EAF0FF] items-center mb-16"
        style="box-shadow: 2px 4px 12px 2px rgba(0, 26, 255, 0.08)">
        <div class="text-font63px w-full xl:w-fit text-[#000000] font-bold leading-[54px]">I Nostri Risulatati</div>
        <div class="w-full xl:w-fit">
            <div class="text-font36px leading-[46px] font-bold text-[#222222] mt-10 xl:mt-0">+10.000</div>
            <div class="text-[#78909C] text-font32px leading-[34px] font-bold">Bandi pubblicati</div>
            <div class="text-font36px leading-[46px] font-bold text-[#222222] mt-10">+200</div>
            <div class="text-[#78909C] text-font32px leading-[34px] font-bold">Appuntamenti telematici</div>
        </div>
        <div class="w-full xl:w-fit">
            <div class="text-font36px leading-[46px] font-bold text-[#222222] mt-10 xl:mt-0">+3.000</div>
            <div class="text-[#78909C] text-font32px leading-[34px] font-bold">Utenti attivi</div>
            <div class="text-font36px leading-[46px] font-bold text-[#222222] mt-10">+500</div>
            <div class="text-[#78909C] text-font32px leading-[34px] font-bold">Startup, PMI ed enti supportati</div>
        </div>
    </div>
</div>